import { createConfirmation } from "react-confirm";
import ResultModal from "./ResultModal";

export const showResultModal = createConfirmation(ResultModal);
